module.exports = __webpack_public_path__ + "img/rprcyz-2.f02a2561.png";